// extracted by mini-css-extract-plugin
module.exports = {"alarm":"alarm-10whyWE5","textLine":"textLine-3BmLMYVH"};